import {_urlBlog, _urlBlogCategory, _urlContact, request} from "../api";
import {BLOGS_CONSTS, UTIL_CONSTS} from "../constants";

export const GetBlog = ({
                            offset = 0,
                            limit = 8,
                            categories = []
                        } = {}) => {
    const requestData = {
        url: `${_urlBlog}?offset=${offset}&limit=${limit}`,
        method: "GET",
        languageFlag: true
    };

    categories && categories.length && (requestData.url += `&categories=${categories.join(',')}`);

    return dispatch => {
        return request(requestData)
            .then(async (res) => {
                const data = res && res.data;
                await dispatch({
                    type: BLOGS_CONSTS.GET_BLOG,
                    payload: {
                        data: data,
                        hasMore: data?.length === limit,
                    }
                })
            })
    };
};
export const GetBlogById = (id) => {
    const requestData = {
        url: `${_urlBlog}/${id}`,
        method: "GET",
        languageFlag: true
    };

    return dispatch => {
        return request(requestData)
            .then(async (res) => {
                const data = res && res.data;
                await dispatch({
                    type: BLOGS_CONSTS.GET_BLOG_BY_ID,
                    payload: data
                })
            })
    };
};
export const GetBlogCategory = () => {
    const requestData = {
        url: `${_urlBlogCategory}`,
        method: "GET",
        languageFlag: true
    };

    return dispatch => {
        return request(requestData)
            .then(async (res) => {
                const data = res && res.data;
                await dispatch({
                    type: BLOGS_CONSTS.GET_BLOG_CATEGORY,
                    payload: data
                })
            })
    };
};

export const SendFeedback = (id,data) => {
    const requestData = {
        url: `${_urlBlog}/${id}`,
        method: "PATCH",
        languageFlag: true,
        data
    };
    return dispatch => {
        dispatch({type: UTIL_CONSTS.START_LOADING});
        return request(requestData).finally(() => {
            dispatch({type: UTIL_CONSTS.END_LOADING})
        })
    }
};